import { render, staticRenderFns } from "./InboxSideMenu.vue?vue&type=template&id=7f25b5c8&"
import script from "./InboxSideMenu.vue?vue&type=script&lang=js&"
export * from "./InboxSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports